import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AwardsModule } from '@features/awards/awards.module';
import { SelectEmailTemplateModule } from '@features/system-emails/select-email-template/select-email-template.module';
import { SystemTagsModule } from '@features/system-tags/system-tags.module';
import { ApproveAwardPayModalComponent } from './approve-award-pay-modal/approve-award-pay-modal.component';
import { BulkApproveAwardPayModalComponent } from './bulk-approve-award-pay-modal/bulk-approve-award-pay-modal.component';

@NgModule({
  imports: [
    GCCoreModule,
    AwardsModule,
    SystemTagsModule,
    SelectEmailTemplateModule
  ],
  declarations: [
    ApproveAwardPayModalComponent,
    BulkApproveAwardPayModalComponent
  ]
})
export class ApproveAwardPayModule { }
